import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '@/router/constants'
import type { ImportWrapper } from '@/types'

export function getKidsRoutes({ registerImport }: { registerImport: ImportWrapper }): RouteRecordRaw[] {
    return [
        {
            path: '',
            name: ROUTE_NAMES.KIDS,
            component: registerImport(() => import('@/pages/Kids/KidsPage.vue')),
            meta: { noLayout: true, noLocaleInRoute: true },
        },
        {
            path: 'error',
            name: ROUTE_NAMES.KIDS_ERROR,
            component: registerImport(() => import('@/pages/Kids/KidsNotFoundPage.vue')),
            meta: { noLayout: true, noLocaleInRoute: true, noIndex: true },
        },
        {
            path: 'parents',
            name: ROUTE_NAMES.KIDS_PARENTS,
            component: registerImport(() => import('@/pages/Kids/KidsLegalPage.vue')),
            props: { page: 'parents' },
            meta: { noLayout: true, noLocaleInRoute: true },
        },
        {
            path: 'privacy-for-kids',
            name: ROUTE_NAMES.KIDS_PRIVACY_FOR_KIDS,
            component: registerImport(() => import('@/pages/Kids/KidsLegalPage.vue')),
            props: { page: 'privacy-for-kids' },
            meta: { noLayout: true, noLocaleInRoute: true },
        },
        {
            path: 'privacy',
            name: ROUTE_NAMES.KIDS_PRIVACY,
            component: registerImport(() => import('@/pages/Kids/KidsLegalPage.vue')),
            props: { page: 'privacy' },
            meta: { noLayout: true, noLocaleInRoute: true },
        },
        {
            path: 'terms-of-use',
            name: ROUTE_NAMES.KIDS_TERMS_OF_USE,
            component: registerImport(() => import('@/pages/Kids/KidsLegalPage.vue')),
            props: { page: 'terms-of-use' },
            meta: { noLayout: true, noLocaleInRoute: true },
        },
        {
            path: ':catchAll(.*)',
            name: ROUTE_NAMES.KIDS_NOT_FOUND,
            component: registerImport(() => import('@/pages/Kids/KidsNotFoundPage.vue')),
            meta: { noLayout: true, noLocaleInRoute: true, noIndex: true },
        },
    ]
}
